import {Link} from "react-router-dom";
import logo from "../../images/logo.png";

const sections = [
  {
    title: "1 – Responsable du traitement",
    paragraphs: [
      "Help Clic exploite l’application web et mobile Help Clic et agit en qualité de responsable du traitement des données personnelles collectées par l’intermédiaire de ses services.",
      "Contact : contact@help-clic.fr\nAdresse : 7 Boulevard de Stalingrad, 94400 Vitry-sur-Seine, France.",
    ],
  },
  {
    title: "2 – Données collectées",
    paragraphs: [
      "Selon votre utilisation de Help Clic, nous pouvons collecter vos informations de compte et de profil : nom, prénom, adresse e-mail, numéro de téléphone, date de naissance, genre, adresse et photo de profil.",
      "Nous pouvons également collecter les justificatifs nécessaires à la vérification des prestataires, les annonces, propositions, réalisations, évaluations, réclamations, messages et pièces jointes publiés, ainsi que les informations relatives aux interventions, aux paiements et aux remboursements.",
      "Les données techniques nécessaires au fonctionnement et à la sécurité peuvent inclure les identifiants de l’appareil, le jeton de notification, les journaux techniques et l’adresse IP. La position ou l’adresse choisie peut être utilisée lors d’une recherche géographique ou de la création d’une annonce.",
    ],
  },
  {
    title: "3 – Utilisation des données",
    paragraphs: [
      "Nous utilisons ces données pour créer et sécuriser votre compte, vérifier les profils prestataires, publier et gérer les annonces, mettre en relation clients et prestataires, assurer la messagerie, organiser les interventions, traiter les paiements et remboursements, envoyer les notifications importantes, répondre aux demandes d’assistance, prévenir la fraude et respecter nos obligations légales.",
    ],
  },
  {
    title: "4 – Connexion avec Facebook, Google ou Apple",
    paragraphs: [
      "Si vous choisissez un service de connexion externe, nous recevons uniquement les données que vous autorisez ce service à nous transmettre.",
      "Pour Facebook Login, Help Clic demande l’accès à votre profil public et, si vous l’autorisez, à votre adresse e-mail. Ces informations servent uniquement à vous authentifier et à créer ou retrouver votre compte Help Clic. Help Clic ne publie aucun contenu sur Facebook en votre nom.",
    ],
  },
  {
    title: "5 – Base légale",
    paragraphs: [
      "Les traitements sont réalisés selon leur finalité sur la base de l’exécution du service demandé, de votre consentement, de nos obligations légales ou de notre intérêt légitime à sécuriser et améliorer la plateforme.",
    ],
  },
  {
    title: "6 – Destinataires et prestataires techniques",
    paragraphs: [
      "Vos données sont accessibles uniquement aux personnes autorisées de Help Clic et, lorsque cela est nécessaire, aux utilisateurs concernés par une annonce ou une intervention.",
      "Nous pouvons faire appel à des prestataires techniques, notamment pour l’hébergement, les paiements sécurisés, les notifications, la cartographie, l’authentification et la maintenance. Ils ne peuvent traiter les données que pour les services qui leur sont confiés et conformément à leurs obligations de protection des données.",
    ],
  },
  {
    title: "7 – Durée de conservation",
    paragraphs: [
      "Nous conservons les données pendant la durée nécessaire à l’utilisation du compte et à la fourniture des services, puis pendant les durées imposées par la loi ou nécessaires à la défense de nos droits.",
      "Après une demande de suppression, le compte peut être restauré pendant 30 jours. À l’issue de ce délai, les données sont supprimées ou anonymisées, sauf lorsqu’une conservation limitée est requise par une obligation légale, comptable, de sécurité ou de prévention de la fraude.",
    ],
  },
  {
    title: "8 – Sécurité",
    paragraphs: [
      "Help Clic met en œuvre des mesures techniques et organisationnelles destinées à protéger les données contre la perte, l’accès non autorisé, l’altération ou la divulgation. Aucun système ne pouvant garantir une sécurité absolue, nous vous recommandons de protéger vos identifiants et de ne jamais communiquer votre mot de passe.",
    ],
  },
  {
    title: "9 – Vos droits",
    paragraphs: [
      "Vous pouvez demander l’accès, la rectification, l’effacement, la limitation ou la portabilité de vos données, ainsi que vous opposer à certains traitements ou retirer votre consentement.",
      "Vous pouvez modifier vos informations depuis votre profil et demander la suppression du compte depuis Paramètres du compte. Vous pouvez également écrire à contact@help-clic.fr. Une preuve d’identité peut être demandée lorsque cela est nécessaire pour protéger votre compte.",
    ],
  },
  {
    title: "10 – Suppression des données Facebook",
    paragraphs: [
      "Vous pouvez retirer Help Clic depuis les paramètres « Applications et sites web » de votre compte Facebook. Pour supprimer les données associées dans Help Clic, utilisez Paramètres du compte > Suppression de compte ou envoyez votre demande à contact@help-clic.fr en précisant l’adresse e-mail de votre compte.",
    ],
  },
  {
    title: "11 – Transferts hors de l’Union européenne",
    paragraphs: [
      "Certains prestataires techniques peuvent traiter des données en dehors de l’Union européenne. Dans ce cas, Help Clic veille à ce que des garanties appropriées soient mises en place conformément à la réglementation applicable.",
    ],
  },
  {
    title: "12 – Modification de la politique",
    paragraphs: [
      "Cette politique peut être mise à jour pour tenir compte de l’évolution du service ou de la réglementation. La date de dernière mise à jour affichée en haut de cette page vous permet d’identifier la version applicable.",
    ],
  },
];

export const PrivacyPolicyPage = ({embedded = false}) => {
  return (
    <div
      className={`${
        embedded ? "w-full" : "min-h-screen"
      } bg-[#f5f7fb] text-[#19295C]`}
    >
      {!embedded && (
        <header className="sticky top-0 z-10 border-b border-[#e4e8f0] bg-white">
          <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
            <Link to="/login" aria-label="Retour à la connexion Help Clic">
              <img src={logo} alt="Help Clic" className="max-h-12" />
            </Link>
            <Link
              to="/login"
              className="rounded-lg border border-[#1A64B9] px-4 py-2 text-sm font-semibold text-[#1A64B9] hover:bg-[#1A64B9] hover:text-white"
            >
              Retour à la connexion
            </Link>
          </div>
        </header>
      )}

      <main
        className={
          embedded
            ? "w-full px-1 py-2 sm:py-4"
            : "mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-12"
        }
      >
        <div className="mb-8 rounded-2xl bg-gradient-to-r from-[#1A64B9] to-[#1238B8] px-6 py-8 text-white shadow-sm sm:px-10">
          <h1 className="mb-2 text-2xl font-bold !text-white sm:text-3xl">
            Politique de confidentialité
          </h1>
          <p className="m-0 text-sm !text-white/90">
            Dernière mise à jour : 14 octobre 2026
          </p>
        </div>

        <div className="space-y-5">
          {sections.map((section) => (
            <section
              key={section.title}
              className="rounded-xl border border-[#e4e8f0] bg-white p-5 shadow-sm sm:p-7"
            >
              <h2 className="mb-3 text-lg font-bold text-[#19295C]">
                {section.title}
              </h2>
              <div className="space-y-3 text-sm leading-7 text-[#3D4465] sm:text-base">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="m-0 whitespace-pre-line">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
